import React from "react";
import { Check, ArrowUpRight, LayoutGrid, Bot, Database, Megaphone } from "lucide-react";
import { SERVICES } from "@/constants/brand";

const ICONS = {
  "enterprise-saas": LayoutGrid,
  "agentic-ai": Bot,
  "data-management": Database,
  "digital-marketing": Megaphone,
};

export const Services = () => {
  const scrollToContact = () => {
    const el = document.querySelector("#contact");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section id="services" data-testid="services-section" className="py-24 md:py-32 bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-14 md:mb-20">
          <div className="lg:col-span-7">
            <p className="uppercase text-xs tracking-[0.22em] font-bold text-[#0055FF]">
              Services
            </p>
            <h2 className="font-display mt-4 text-4xl md:text-5xl tracking-tight font-bold text-[#0B1120] leading-tight">
              Four practices. One outcome — a business that scales without breaking.
            </h2>
          </div>
          <div className="lg:col-span-5 lg:pl-8">
            <p className="text-base md:text-lg text-[#475569] leading-relaxed">
              We don’t sell modules — we deliver capabilities. Each engagement is sized
              for SMEs, structured for ROI, and architected to compound over time.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-6 gap-6 md:gap-8">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.id] || LayoutGrid;
            return (
              <div
                key={s.id}
                data-testid={`service-card-${s.id}`}
                className={`tracing-beam group relative bg-white border border-[#E2E8F0] rounded-sm p-8 md:p-10 shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1 ${s.span}`}
              >
                <div className="flex items-start justify-between">
                  <div className="inline-flex items-center justify-center h-12 w-12 border border-[#E2E8F0] rounded-sm bg-[#FAFAFA] text-[#1B2A6E] group-hover:bg-[#1B2A6E] group-hover:text-white transition-colors">
                    <Icon className="h-5 w-5" />
                  </div>
                  <span className="font-display text-sm font-bold text-[#94A3B8]">
                    {s.eyebrow}
                  </span>
                </div>

                <h3 className="font-display mt-7 text-2xl md:text-3xl font-bold text-[#0B1120] leading-tight">
                  {s.title}
                </h3>
                <p className="mt-2 text-sm uppercase tracking-[0.16em] font-semibold text-[#0055FF]">
                  {s.subtitle}
                </p>
                <p className="mt-5 text-[15px] text-[#475569] leading-relaxed">
                  {s.description}
                </p>

                <ul className="mt-6 space-y-3">
                  {s.bullets.map((b) => (
                    <li key={b} className="flex items-start gap-3 text-sm text-[#0B1120]">
                      <Check className="h-4 w-4 mt-0.5 text-[#0055FF] flex-shrink-0" />
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>

                <button
                  onClick={scrollToContact}
                  data-testid={`service-card-cta-${s.id}`}
                  className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-[#1B2A6E] hover:text-[#0055FF] transition-colors"
                >
                  Discuss this service
                  <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
